








import {
    Component,
    Vue
} from 'vue-property-decorator';
import Heading from '@/components/heading/index.vue';
import BannerHome from '@/components/banner-home/index.vue';

@Component({
    components: {
        Heading,
        BannerHome
    }
})
export default class Home extends Vue {
    private imgUrl: string = require('../../assets/img/stock-photo-134067119.jpg');
    private data: any = [];
    private created() {
        this.getBlogData();
    }
    private getBlogData(): void {
        this.$axios.get('/data/blog.json').then((res: any) => {
            this.data = res.data.slice(0, 2);
        });
    }
}
